import { RouteInfo } from "./types";
import { authGuard, permissionGuard } from "./guards/index";
import { UIPAGE } from "@/constants/ui-page.constants";

const ViewTrackingSaleProcesses = () =>
	import(/* webpackChunkName: "chunk-tracking-sale-processes" */ "@/views/tracking-sale-processes/TrackingSaleProcesses.vue");

export const TrackingSaleProcessesRoute: RouteInfo = {
	id: UIPAGE.TRACKING_LEADS,
	path: "/tracking",
	component: ViewTrackingSaleProcesses,
	guards: [authGuard, permissionGuard],
	title: "tracking.display",
	icon: "mdi-chart-line-variant"
};
